import { Table } from 'components/Display/Table/Table';

export const SkeletonLoadingRows = ({
  nRows,
  nCols,
  withBulkActionsCol,
}: {
  nRows?: number;
  nCols?: number;
  withBulkActionsCol?: boolean;
}) => {
  if (!nRows || !nCols) {
    return null;
  }

  return Array.from({ length: nRows }).map((_, rowIndex) => (
    <Table.Row key={`loading-more-${rowIndex}`}>
      {withBulkActionsCol ? <Table.Cell /> : null}
      {Array.from({ length: nCols }).map((_, colIndex) => (
        <Table.Cell key={`loading-more-${rowIndex}-${colIndex}`}>
          <div className="h-4 w-3/4 animate-pulse rounded bg-gray-200" />
        </Table.Cell>
      ))}
    </Table.Row>
  ));
};
